$(document).ready(function () {

    $("#taskPanel button.buttonCollapse").click(function () {
        if ($("#collapseTask").prop('style').height !== '0px') {
            $("#taskPanel ul li").removeClass('active');
        } else {
            if ($("#newTask").prop('style').display == 'block') {
                $("[aria-controls=newTask]").addClass('active');
            } else if ($("#futureTask").prop('style').display == 'block') {
                $("[aria-controls=futureTask]").addClass('active');
            } else if ($("#overdueTask").prop('style').display == 'block') {
                $("[aria-controls=overdueTask]").addClass('active');
            }
            ;
        }
        ;
    });

    $("#keyFiguresPanel button.buttonCollapse").click(function () {
        if ($("#collapseKeyFigures").prop('style').height !== '0px') {
            $("#keyFiguresPanel ul li").removeClass('active');
        } else {
            if ($("#interestedParties").prop('style').display == 'block') {
                $("[aria-controls=interestedParties]").addClass('active');
            } else if ($("#candidate").prop('style').display == 'block') {
                $("[aria-controls=candidate]").addClass('active');
            }
            ;
        }
        ;
    });

    $("#birthdayPanel button.buttonCollapse").click(function () {
        if ($("#collapseBirthday").prop('style').height !== '0px') {
            $("#birthdayPanel ul li").removeClass('active');
        } else {
            if ($("#birthdayTomorow").prop('style').display == 'block') {
                $("[aria-controls=birthdayTomorow]").addClass('active');
            } else if ($("#birthdayToday").prop('style').display == 'block') {
                $("[aria-controls=birthdayToday]").addClass('active');
            }
            ;
        }
        ;
    });

    $("#jobPanel button.buttonCollapse").click(function () {
        if ($("#collapseJobs").prop('style').height !== '0px') {
            $("#jobPanel ul li").removeClass('active');
        } else {
            if ($("#newJob").prop('style').display == 'block') {
                $("[aria-controls=newJob]").addClass('active');
            } else if ($("#oldJob").prop('style').display == 'block') {
                $("[aria-controls=oldJob]").addClass('active');
            }
            ;
        }});

    $("#recentLogPanel button.buttonCollapse").click(function () {
        if ($("#collapseRecentLog").prop('style').height !== '0px') {
            $("#recentLogPanel ul li").removeClass('active');
        } else {
            if ($("#candidatesLog").prop('style').display === 'block') {
                $("[aria-controls=candidatesLog]").addClass('active');
            } else if ($("#companiesLog").prop('style').display === 'block') {
                $("[aria-controls=companiesLog]").addClass('active');
            } else if ($("#projectsLog").prop('style').display === 'block') {
                $("[aria-controls=projectsLog]").addClass('active');
            } else if ($("#companyContactsLog").prop('style').display === 'block') {
                $("[aria-controls=companyContactsLog]").addClass('active');
            }
        }
    });


    $("#taskPanel li").click(function () {
        $("#collapseTask").show();
        $("#collapseTask").removeAttr('style');
        $('#collapseTask').addClass('in');
    });
    $("#keyFiguresPanel li").click(function () {
        $("#collapseKeyFigures").show();
        $("#collapseKeyFigures").removeAttr('style');
        $('#collapseKeyFigures').addClass('in');
    });
    $("#birthdayPanel li").click(function () {
        $("#collapseBirthday").show();
        $("#collapseBirthday").removeAttr('style');
        $('#collapseBirthday').addClass('in');
    });
    $("#jobPanel li").click(function () {
        $("#collapseJobs").show();
        $("#collapseJobs").removeAttr('style');
        $('#collapseJobs').addClass('in');
    });
});